export enum AppHashTag {
  EXPLORER = '#explorer',
  EDITOR = '#editor',
  POINTS = '#comments',
  AUDIO_CURRENT_TIME = 's',
}
